"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CloseButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tracking = _interopRequireDefault(require("@site/pattern-library-utils/tracking"));
const closeButtonstyles = "core-c1y6sif5";
function CloseButton({
  onClose,
  className,
  style,
  partial = null
}) {
  const dataPartial = partial ? {
    'data-partial': partial
  } : {};
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    "data-cy": "close-button",
    "aria-label": "close-button",
    className: `${closeButtonstyles} ${className || null}`,
    onClick: () => onClose(),
    style: style || null
  }, dataPartial, _tracking.default.create('dismiss', true, false)), /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: "x",
    width: "24px",
    height: "24px",
    className: "close",
    fill: _intents.default.ux.box.foregroundColor
  }));
}
CloseButton.propTypes = {
  onClose: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  partial: _propTypes.default.string
};